var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLineArrowLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 15.001,
    viewBox: "0 0 30 15.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M7.079,14.654.368,8.338A1.15,1.15,0,0,1,0,7.562V7.555Q0,7.528,0,7.5t0-.07a1.15,1.15,0,0,1,.366-.767L7.079.347a1.314,1.314,0,0,1,1.779,0,1.136,1.136,0,0,1,0,1.675L4.295,6.316H28.548A1.338,1.338,0,0,1,30,7.5a1.338,1.338,0,0,1-1.452,1.184H4.3l4.562,4.295a1.136,1.136,0,0,1,0,1.675,1.316,1.316,0,0,1-1.779,0Z",
    transform: "translate(0 0)",
    fill: "#1a051d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineArrowLeft);
export default __webpack_public_path__ + "static/media/line-arrow-left.62cac523405687b7f9b1ec02086a64cf.svg";
export { ForwardRef as ReactComponent };